import { DEFAULT_RECURRING_CHARGE_CONFIG, PAYMENT_METHOD_FIELDS } from './fields';

// Programs saved before frequencies became multi-select stored a single `frequency` and an
// `amount` that capped each payment; the cadence carries over, the amount no longer applies.
export const normalizeRecurringConfig = (method) => {
  if (method.field !== PAYMENT_METHOD_FIELDS.RECURRING_CHARGE) return method;

  const frequencies = Array.isArray(method.config?.frequencies)
    ? method.config.frequencies.filter(Boolean)
    : [method.config?.frequency].filter(Boolean);

  const resolved = frequencies.length ? frequencies : DEFAULT_RECURRING_CHARGE_CONFIG.frequencies;

  return {
    ...method,
    config: { ...method.config, frequencies: resolved, frequency: resolved[0] }
  };
};
